 export const onAnchorClick = (e, nuxtHref, nuxtPathname, user) => {
   if (!CONFIG.isNuxt || !CONFIG.urls.profile(user)) {
     return
   }
   e.preventDefault();
   if (window && typeof window.nuxtNavigate === 'function') {
     window.nuxtNavigate(nuxtPathname);
   } else {
     window.location.pathname = nuxtPathname;
   }
  }
